<template>
  <img :src="src" alt="" v-bind="$attrs">
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    }
  },
  computed: {
    src () {
      return `${process.env.IFRAME_URL}/${this.name}.svg`
    }
  }
}
</script>
